function isEnabled(value) {
  return ["1", "true", "yes", "on"].includes(
    String(value || "")
      .trim()
      .toLowerCase(),
  );
}

export const SHOW_FULL_RESULTS = isEnabled(
  process.env.SHOW_FULL_RESULTS ?? process.env.REACT_APP_SHOW_FULL_RESULTS,
);

export function resolveShowFullResults(productPresentationProfile) {
  // Full-result expansion is a demo-only escape hatch. Real deployments are
  // driven by the resolved product-presentation profile feature flags instead.
  return (
    Boolean(productPresentationProfile?.userWebApp?.misc?.demoModeEnabled) &&
    SHOW_FULL_RESULTS
  );
}
